<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Логи</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-card>
                    <!--                    <v-card-title>-->
                    <!--                        <v-row align="center">-->
                    <!--                            <v-col>-->
                    <!--                                <br>-->

                    <!--                                <v-select-->
                    <!--                                    :items="items"-->
                    <!--                                    v-model="date"-->
                    <!--                                    label="Укажите дату"-->
                    <!--                                ></v-select>-->
                    <!--                            </v-col>-->

                    <!--                            <v-col class="d-flex">-->
                    <!--                                <v-spacer></v-spacer>-->
                    <!--                            </v-col>-->

                    <!--                            <v-col class="d-flex">-->
                    <!--                                <v-text-field-->
                    <!--                                    v-model="search"-->
                    <!--                                    append-icon="mdi-magnify"-->
                    <!--                                    label="Поиск"-->
                    <!--                                    single-line-->
                    <!--                                    hide-details-->
                    <!--                                ></v-text-field>-->
                    <!--                            </v-col>-->
                    <!--                        </v-row>-->
                    <!--                    </v-card-title>-->

                    <v-data-table
                        :headers="headers"
                        :items="logs"
                        :items-per-page="15"
                        :loading="tableLoader"
                        :options.sync="options"
                        :server-items-length="totalLogs"
                        class="elevation-1"
                    ></v-data-table>
                </v-card>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'statisticLogs',
        components: {
            Loader,
        },
        data: () => ({
            loading: false,
            totalLogs: 0,
            options: {},
            current_page: 1,
            last_page: 1,
            // date: 'all',
            // items: [
            //     {
            //         text: 'День',
            //         value: 'day'
            //     },
            //     {
            //         text: 'Неделя',
            //         value: 'week'
            //     },
            //     {
            //         text: 'Месяц',
            //         value: 'month'
            //     },
            //     {
            //         text: 'Последний год',
            //         value: 'year'
            //     },
            //     {
            //         text: 'Все время',
            //         value: 'all'
            //     }
            // ],
            tableLoader: false,
            // search: '',
            // excel_headers: {
            //     'Пользователь': 'full_name',
            //     'Действие': 'action',
            //     'IP адрес': 'ip',
            //     'Дата': 'created_at',
            // },
            headers: [
                // { text: 'ID', value: 'id' },
                {
                    text: 'Пользователь',
                    value: 'full_name'
                },
                {
                    text: 'Действие',
                    value: 'action'
                },
                {
                    text: 'IP адрес',
                    value: 'ip'
                },
                {
                    text: 'Дата',
                    value: 'created_at'
                },
            ],
            logs: [],
        }),

        watch: {
            // date (val) {
            //     this.getLogs()
            // },

            options: {
                handler () {
                    this.getLogs()
                },
                deep: true,
            },
        },

        mounted () {
            // this.getLogs()
        },

        created () {
            this.setHeaderTitle('Логи')
        },

        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            },

            getLogs () {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options

                let last_page = this.last_page
                if (page > last_page) return

                this.tableLoader = true

                Statistic
                    .getLogsStat(page, itemsPerPage, sortBy, sortDesc)
                    .then(({ data }) => {
                        // this.desserts = data.items
                        // this.totalDesserts = data.total
                        this.current_page = data.data.current_page
                        this.last_page = data.data.last_page
                        this.logs = data.data.data
                        this.totalLogs = data.data.total
                    })
                    .catch(error => new Error(error))
                    .finally(() => this.tableLoader = false)
            },
        }
    }
</script>

<style lang="scss">

</style>
